import { FC } from 'react';
import { ImSpinner8 } from 'react-icons/im';
import styled, { keyframes, Keyframes } from 'styled-components';
import { HStack } from '@bpba/ui-components';
import { WidthProps } from 'styled-system';

export const Spinner: FC<WidthProps> = (props) => {
  return (
    <HStack justifyContent="center" marginY={48} aria-label="Procesando. Aguarde por favor." tabIndex={0} color="primary.0" {...props}>
      <SpinnerIcon />
    </HStack>
  );
};

const spinnerAnimation: Keyframes = keyframes`
    0% { transform: rotate(0deg);}
    100% { transform: rotate(359deg);}
`;

const SpinnerIcon = styled(ImSpinner8)`
  height: 35px;
  width: 35px;
  animation: ${spinnerAnimation} 2s infinite linear;
`;
